import Property2RightGridContainer from "../../../components/property/grid/Property2RightGrid";

const Property2RightGrid = () => {
  return <Property2RightGridContainer />;
};

export default Property2RightGrid;
